import { useState, useCallback } from "react";

type FilterTransformer<T> = (filters: T) => T;

interface UseFiltersOptions<T> {
  defaults: T;
  transform?: FilterTransformer<T>;
}

export function useFilters<T>({ defaults, transform }: UseFiltersOptions<T>) {
  const [filters, setFilters] = useState<T>(defaults);
  const [appliedFilters, setAppliedFilters] = useState<T>(defaults);

  const handleChange = useCallback((field: keyof T, value: string) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  }, []);

  const apply = useCallback(() => {
    const converted = transform ? transform(filters) : filters;
    setAppliedFilters(converted);
  }, [filters, transform]);

  const reset = useCallback(() => {
    setFilters(defaults);
    setAppliedFilters(defaults);
  }, [defaults]);

  return {
    filters,
    appliedFilters,
    handleChange,
    apply,
    reset,
  };
}
